// extracted by mini-css-extract-plugin
var _1 = "Yks6X__userType";
var _2 = "Yks6X__userType_adm";
var _3 = "Yks6X__userType_bot";
var _4 = "Yks6X__userType_dev";
var _5 = "Yks6X__userType_mod";
var _6 = "Yks6X__userType_vip";
export { _1 as "userType", _2 as "userType_adm", _3 as "userType_bot", _4 as "userType_dev", _5 as "userType_mod", _6 as "userType_vip" }
